import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
import { recentPurchases } from '../data/recentPurchases';
const SHOW_MS = 4500;
const GAP_MS = 8000;
const START_DELAY_MS = 3000;
export function RecentPurchaseToast() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [minutesAgo, setMinutesAgo] = useState(3);
  useEffect(() => {
    if (dismissed) return;
    let hideTimeout: ReturnType<typeof setTimeout>;
    let cycleInterval: ReturnType<typeof setInterval>;
    const startTimeout = setTimeout(() => {
      setVisible(true);
      hideTimeout = setTimeout(() => setVisible(false), SHOW_MS);
      cycleInterval = setInterval(() => {
        setIndex(i => (i + 1) % recentPurchases.length);
        setMinutesAgo(2 + Math.floor(Math.random() * 13));
        setVisible(true);
        hideTimeout = setTimeout(() => setVisible(false), SHOW_MS);
      }, GAP_MS);
    }, START_DELAY_MS);
    return () => {
      clearTimeout(startTimeout);
      clearTimeout(hideTimeout);
      clearInterval(cycleInterval);
    };
  }, [dismissed]);
  if (dismissed) return null;
  const purchase = recentPurchases[index];
  return <div className="fixed bottom-24 left-4 z-30 sm:bottom-6 sm:left-6" role="status" aria-live="polite" data-id="element-130" data-mp="2i2b9uf1ikpxg">
      <AnimatePresence data-id="element-131" data-mp="1ubxmh1tvjf97">
        {visible && <motion.div initial={{
        opacity: 0,
        y: 12,
        x: -8
      }} animate={{
        opacity: 1,
        y: 0,
        x: 0
      }} exit={{
        opacity: 0,
        y: 8
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="flex max-w-[280px] items-start gap-3 rounded-xl border border-gray-200 bg-white p-4 shadow-lg" data-id="element-132" data-mp="1pckrftsun1vj">
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-mint-deep text-mint-dark" data-id="element-133" data-mp="3fqv2mju65ovb">
              <ShoppingBagIcon className="h-4 w-4" aria-hidden="true" data-id="element-134" data-mp="3hsvpl30aa3qg" />
            </span>
            <div className="flex-1" data-id="element-135" data-mp="3hv84f7aqvxza">
              <p className="text-sm font-semibold text-gray-800" data-id="element-136" data-mp="3mr5ljftu18d4">
                {purchase.nombre} de {purchase.ciudad}
              </p>
              <p className="mt-0.5 text-xs text-gray-500" data-id="element-137" data-mp="3rrtalvyi3f4p">Acaba de comprar · hace {minutesAgo} min</p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Cerrar notificación" className="text-gray-400 transition-colors duration-150 ease-out hover:text-gray-600" data-id="element-138" data-mp="ie46z4ahcl4">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-139" data-mp="38zs6of6vcyof" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}